export * from "ce/constants/forms";
export const SSO_IDENTITY_PROVIDER_FORM = "SsoIdentityProvider";
export const SSO_PROVIDER_ATTRIBUTE_FORM = "SsoProviderAttribute";
export const QUERY_MODULE_INSTANCE_SETTINGS_FORM_NAME =
  "QueryModuleInstanceSettingsForm";
